import React from 'react';

function MaintenancePage() {
  return (
    <div className="flex-1 bg-[#0b0d2a] flex items-center justify-center px-4 py-20">
      <div className="max-w-lg w-full text-center">
        <div className="text-6xl mb-6 select-none">&#9881;</div>

        <h1 className="text-2xl font-semibold text-white mb-3">
          We'll Be Right Back
        </h1>

        <p className="text-gray-400 mb-6 leading-relaxed">
          Quantum Flo is currently undergoing scheduled maintenance to improve
          your experience. This won't take long.
        </p>

        <div className="bg-[#0d0d1a] border border-gray-700 rounded-lg p-5 mb-8">
          <p className="text-gray-300 text-sm">
            All active positions and automated strategies remain safely managed
            during maintenance. No action is needed on your part.
          </p>
        </div>

        <button
          onClick={() => window.location.reload()}
          className="px-6 py-3 bg-purple-600 text-white rounded-lg font-medium hover:bg-purple-500 transition-colors"
        >
          Refresh Page
        </button>

        <p className="text-gray-600 text-xs mt-8">
          If this persists, please contact support.
        </p>
      </div>
    </div>
  );
}

export default MaintenancePage;
